import { Route } from '@angular/router';
import { Path } from './enum/path.enum';
import { maintainanceGuard } from './guard/maintainance.guard';
import { notLoggedGuard } from './guard/not-logged.guard';
import { notMaintainanceGuard } from './guard/not-maintainance.guard';
import { loggedInGuard } from './guard/logged-in.guard';
import { refreshPasswordGuard } from './guard/refresh-password.guard';

export const appRoutes: Route[] = [
  {
    path: Path.HOME,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    children: [
      {
        path: Path.ERROR,
        loadComponent: () =>
          import('./pages/common/error/error.component').then(
            (x) => x.ErrorComponent
          ),
      },
      {
        path: Path.LOGIN,
        loadComponent: () =>
          import('./pages/common/login/login.component').then(
            (x) => x.LoginComponent
          ),
        canActivate: [notLoggedGuard, maintainanceGuard],
      },
      {
        path: Path.RECUPERO_PASSWORD,
        loadComponent: () =>
          import(
            './pages/common/retrieve-password/retrieve-password.component'
          ).then((x) => x.RetrievePasswordComponent),
        canActivate: [notLoggedGuard, maintainanceGuard],
      },
      {
        path: Path.MANUTENZIONE,
        loadComponent: () =>
          import('./pages/common/maintainance/maintainance.component').then(
            (x) => x.MaintainanceComponent
          ),
        canActivate: [notMaintainanceGuard],
      },
      {
        path: Path.CAMBIO_PASSWORD,
        loadComponent: () =>
          import(
            './pages/common/change-password/change-password.component'
          ).then((x) => x.ChangePasswordComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.RENDICONTAZIONE,
        loadComponent: () =>
          import('./pages/rendicontazione/rendicontazione.component').then(
            (x) => x.RendicontazioneComponent
          ),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.DOCUMENTS,
        loadComponent: () =>
          import('./pages/documents/documents.component').then(
            (x) => x.DocumentsComponent
          ),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.REPORT_RETE_TERZA}`,
      },
    ],
  },
  {
    path: Path.ANAGRAPHIC,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.ANAGRAPHIC}/${Path.ANAGRAPHIC_MANAGEMENT}`,
      },
      {
        path: Path.ANAGRAPHIC_MANAGEMENT,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/anagraphic-management/anagraphic-management.component'
          ).then((x) => x.AnagraphicManagementComponent),
      },
      {
        path: Path.INSERT,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/insert-anagraphic/insert-anagraphic.component'
          ).then((x) => x.InsertAnagaphicComponent),
      },
      {
        path: `${Path.DOCUMENTS}/:sigla`,
        loadComponent: () =>
          import('./pages/documents/documents.component').then(
            (x) => x.DocumentsComponent
          ),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: `${Path.OPERATIONS}/:sigla`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/operations/operations.component'
          ).then((x) => x.OperationsComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
        children: [
          {
            path: Path.ANAGRAPHIC_NEW_OPERATION,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/new-operation/new-operation.component'
              ).then((x) => x.NewOperationComponent),
          },
          {
            path: Path.ANAGRAPHIC_MONITORAGGIO,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/monitoring/monitoring.component'
              ).then((x) => x.MonitoringComponent),
          },
          {
            path: `${Path.ANAGRAPHIC_MONITORAGGIO}/${Path.DETAIL}/:id`,
            loadComponent: () =>
              import(
                './components/general-operation-detail/general-operation-detail.component'
              ).then((x) => x.GeneralOperationDetailComponent),
          },
          {
            path: Path.HISTORY,
            loadComponent: () =>
              import('./pages/anagraphic/pages/history/history.component').then(
                (x) => x.HistoryComponent
              ),
          },
          {
            path: `${Path.HISTORY}/${Path.DETAIL}/:id`,
            loadComponent: () =>
              import(
                './components/general-operation-detail/general-operation-detail.component'
              ).then((x) => x.GeneralOperationDetailComponent),
          },
          {
            path: Path.INTERFACE_MONITORING,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-monitoring/interface-monitoring.component'
              ).then((x) => x.InterfaceMonitoringComponent),
            canActivate: [loggedInGuard, maintainanceGuard],
          },
          {
            path: `${Path.INTERFACE_MONITORING}/${Path.DETAIL}/:type/:id`,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-detail/interface-detail.component'
              ).then((x) => x.InterfaceDetailComponent),
            canActivate: [loggedInGuard, maintainanceGuard],
          },
          {
            path: Path.INTERFACE_HISTORY,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-history/interface-history.component'
              ).then((x) => x.InterfaceHistoryComponent),
          },
          {
            path: `${Path.INTERFACE_HISTORY}/${Path.DETAIL}/:type/:id`,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-detail/interface-detail.component'
              ).then((x) => x.InterfaceDetailComponent),
            canActivate: [loggedInGuard, maintainanceGuard],
          },
          {
            path: Path.HOME,
            pathMatch: 'full',
            redirectTo: `${Path.ANAGRAPHIC_NEW_OPERATION}`,
          },
        ],
      },
      {
        path: `${Path.OPERATIONS_LOCKER}/:sigla`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/operations-locker/operations-locker.component'
          ).then((x) => x.OperationsLockerComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
        children: [
          {
            path: Path.ANAGRAPHIC_NEW_OPERATION,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/new-operation-locker/new-operation-locker.component'
              ).then((x) => x.NewOperationLockerComponent),
          },
          {
            path: Path.ANAGRAPHIC_MONITORAGGIO,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/monitoring-locker/monitoring-locker.component'
              ).then((x) => x.MonitoringLockerComponent),
          },
          {
            path: `${Path.ANAGRAPHIC_MONITORAGGIO}/${Path.DETAIL}/:id`,
            loadComponent: () =>
              import(
                './components/general-operation-detail-locker/general-operation-detail-locker.component'
              ).then((x) => x.GeneralOperationDetailLockerComponent),
          },
          {
            path: Path.HISTORY,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/history-locker/history-locker.component'
              ).then((x) => x.HistoryLockerComponent),
          },
          {
            path: `${Path.HISTORY}/${Path.DETAIL}/:id`,
            loadComponent: () =>
              import(
                './components/general-operation-detail-locker/general-operation-detail-locker.component'
              ).then((x) => x.GeneralOperationDetailLockerComponent),
          },
          {
            path: Path.INTERFACE_MONITORING,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-monitoring-locker/interface-monitoring-locker.component'
              ).then((x) => x.InterfaceMonitoringLockerComponent),
            canActivate: [loggedInGuard, maintainanceGuard],
          },
          {
            path: `${Path.INTERFACE_MONITORING}/${Path.DETAIL}/:type/:id`,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-detail-locker/interface-detail-locker.component'
              ).then((x) => x.InterfaceDetailComponentLocker),
            canActivate: [loggedInGuard, maintainanceGuard],
          },
          {
            path: Path.INTERFACE_HISTORY,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-history-locker/interface-history-locker.component'
              ).then((x) => x.InterfaceHistoryLockerComponent),
          },
          {
            path: `${Path.INTERFACE_HISTORY}/${Path.DETAIL}/:type/:id`,
            loadComponent: () =>
              import(
                './pages/anagraphic/pages/interface-detail-locker/interface-detail-locker.component'
              ).then((x) => x.InterfaceDetailComponentLocker),
            canActivate: [loggedInGuard, maintainanceGuard],
          },
          {
            path: Path.HOME,
            pathMatch: 'full',
            redirectTo: `${Path.ANAGRAPHIC_NEW_OPERATION}`,
          },
        ],
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/points-management/points-management.component'
          ).then((x) => x.PointsManagementComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.MASSIVE_UPLOAD}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.POINTS_MANAGEMENT_DETAIL}/:id`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/points-management/pages/point-detail/point-detail.component'
          ).then((x) => x.PointDetailComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.POINTS_MANAGEMENT_DETAIL_LOCKER}/:id`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/points-management/pages/point-detail/point-detail.component'
          ).then((x) => x.PointDetailComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.POINTS_MANAGEMENT_DETAIL}/:id/${Path.REPORT_GIACENZA}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/report-giacenza/report-giacenza.component'
          ).then((x) => x.ReportGiacenzaComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.POINTS_MANAGEMENT_DETAIL_LOCKER}/:id/${Path.REPORT_GIACENZA_LOCKER}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/report-giacenza-locker/report-giacenza-locker.component'
          ).then((x) => x.ReportGiacenzaLockerComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.EDIT_RETE_TERZA}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/points-management/pages/edit-rete-terza/edit-rete-terza.component'
          ).then((x) => x.EditReteTerzaComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.ATTIVAZIONE_MASSIVA}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/attivazione-massiva/attivazione-massiva.component'
          ).then((x) => x.AttivazioneMassivaComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.PREATTIVAZIONE_MASSIVA}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/attivazione-massiva/attivazione-massiva.component'
          ).then((x) => x.AttivazioneMassivaComponent),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.EXTRACTION_MIG2}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/extraction-mig2/extraction-mig2.component'
          ).then((x) => x.ExtractionMig2Component),
      },
      {
        path: `${Path.POINTS_MANAGEMENT}/:sigla/${Path.PREATTIVAZIONE}`,
        loadComponent: () =>
          import(
            './pages/anagraphic/pages/attivazione-massiva/attivazione-massiva.component'
          ).then((x) => x.AttivazioneMassivaComponent),
      },
    ],
  },
  {
    path: Path.REPORT_RETE_TERZA,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: Path.HOME,
        loadComponent: () =>
          import(
            './components/filter-report-rete-terza/filter-report-rete-terza.component'
          ).then((x) => x.FilterReportReteTerzaComponent),
        children: [
          {
            path: Path.HOME,
            loadComponent: () =>
              import(
                './pages/report-rete-terza/report-rete-terza.component'
              ).then((x) => x.ReportReteTerzaComponent),
          },
          {
            path: `${Path.POINT_POST}/:searchId`,
            loadComponent: () =>
              import('./pages/point-post/point-post.component').then(
                (x) => x.PointPostComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: `${Path.REPORT_RETE_TERZA}/${Path.POINT_POST}/:searchId`,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: `${Path.DETAIL}/:id`,
        loadComponent: () =>
          import('./pages/point-post-detail/point-post-detail.component').then(
            (x) => x.PointPostDetailComponent
          ),
      },
    ],
  },
  {
    path: `${Path.HOME}`,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    children: [
      {
        path: `${Path.POINT_POST}/:searchId`,
        loadComponent: () =>
          import('./pages/point-post/point-post.component').then(
            (x) => x.PointPostComponent
          ),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: `${Path.POINT_POST}/:searchId/${Path.DETAIL}/:id`,
        loadComponent: () =>
          import('./pages/point-post-detail/point-post-detail.component').then(
            (x) => x.PointPostDetailComponent
          ),
      },
    ],
  },
  /*
    REGOLA DI ROUTING PER IL PATH REPORT RETI LOCKER
    CARICA NEL COMPONENTE BASIC IL COMPONENTE REPORT RETI LOCKER
  */
  {
    path: Path.REPORT_RETI_LOCKER,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: Path.HOME,
        loadComponent: () =>
          import(
            './components/filter-report-reti-locker/filter-report-reti-locker.component'
          ).then((x) => x.FilterReportRetiLockerComponent),
        children: [
          {
            path: Path.HOME,
            loadComponent: () =>
              import(
                './pages/report-reti-locker/report-reti-locker.component'
              ).then((x) => x.ReportRetiLockerComponent),
          },
          {
            path: `${Path.POINT_POST_LOCKER}/:searchId`,
            loadComponent: () =>
              import(
                './pages/point-post-locker/point-post-locker.component'
              ).then((x) => x.PointPostLockerComponent),
          },
        ],
      },
    ],
  },
  {
    path: `${Path.REPORT_RETI_LOCKER}/${Path.POINT_POST_LOCKER}/:searchId`,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: `${Path.DETAIL}/:id`,
        loadComponent: () =>
          import(
            './pages/point-post-locker-detail/point-post-locker-detail.component'
          ).then((x) => x.PointPostLockerDetailComponent),
      },
    ],
  },
  {
    path: `${Path.HOME}`,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    children: [
      {
        path: `${Path.POINT_POST_LOCKER}/:searchId`,
        loadComponent: () =>
          import('./pages/point-post-locker/point-post-locker.component').then(
            (x) => x.PointPostLockerComponent
          ),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: `${Path.POINT_POST_LOCKER}/:searchId/${Path.DETAIL}/:id`,
        loadComponent: () =>
          import(
            './pages/point-post-locker-detail/point-post-locker-detail.component'
          ).then((x) => x.PointPostLockerDetailComponent),
      },
    ],
  },

  {
    path: Path.COMUNICATION,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: Path.HEADER,
        loadComponent: () =>
          import(
            './pages/comunications/header-comunication/header-comunication.component'
          ).then((x) => x.HeaderComunicationComponent),
      },
      {
        path: Path.NOTICEBOARD,
        loadComponent: () =>
          import(
            './pages/comunications/noticeboard-comunication/noticeboard-comunication.component'
          ).then((x) => x.NoticeboardComunicationComponent),
      },
      {
        path: Path.RECIPIENTS,
        loadComponent: () =>
          import(
            './pages/comunications/recipients-comunication/recipients-comunication.component'
          ).then((x) => x.RecipientsComunicationComponent),
      },
      {
        path: `${Path.HEADER}/${Path.DETAIL}/:id`,
        loadComponent: () =>
          import(
            './pages/comunications/header-detail/header-detail.component'
          ).then((x) => x.HeaderDetailComponent),
      },
      {
        path: `${Path.HEADER}/${Path.CREATE}`,
        loadComponent: () =>
          import(
            './pages/comunications/header-detail/header-detail.component'
          ).then((x) => x.HeaderDetailComponent),
      },
      {
        path: `${Path.NOTICEBOARD}/${Path.DETAIL}/:id`,
        loadComponent: () =>
          import(
            './pages/comunications/noticeboard-detail/noticeboard-detail.component'
          ).then((x) => x.NoticeboardDetailComponent),
      },
      {
        path: `${Path.RECIPIENTS}/${Path.DETAIL}/:id`,
        loadComponent: () =>
          import(
            './pages/comunications/recipients-detail/recipients-detail.component'
          ).then((x) => x.RecipientsDetailComponent),
      },
      {
        path: `${Path.HEADER}/${Path.CREATE}`,
        loadComponent: () =>
          import(
            './pages/comunications/recipients-detail/recipients-detail.component'
          ).then((x) => x.RecipientsDetailComponent),
      },
      {
        path: `${Path.NOTICEBOARD}/${Path.CREATE}`,
        loadComponent: () =>
          import(
            './pages/comunications/noticeboard-detail/noticeboard-detail.component'
          ).then((x) => x.NoticeboardDetailComponent),
      },
      {
        path: `${Path.RECIPIENTS}/${Path.CREATE}`,
        loadComponent: () =>
          import(
            './pages/comunications/recipients-detail/recipients-detail.component'
          ).then((x) => x.RecipientsDetailComponent),
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.COMUNICATION}/${Path.HEADER}`,
      },
    ],
  },
  {
    path: Path.UTILITY,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    children: [
      {
        path: Path.BOXLESS,
        loadComponent: () =>
          import(
            './pages/utility/boxless-configuration/boxless-configuration.component'
          ).then((x) => x.BoxlessConfigurationComponent),
      },
      {
        path: Path.COMPENSI,
        loadComponent: () =>
          import('./pages/utility/compensi/compensi.component').then(
            (x) => x.CompensiComponent
          ),
      },
      {
        path: Path.REPORT_PUNTO_POSTE,
        loadComponent: () =>
          import(
            './pages/utility/report-punto-poste/report-punto-poste.component'
          ).then((x) => x.ReportPuntoPosteComponent),
      },
      {
        path: Path.DELIVERY_STUCTURE,
        loadComponent: () =>
          import(
            './pages/utility/delivery-structure/delivery-structure.component'
          ).then((x) => x.DeliveryStructureComponent),
      },
      {
        path: Path.SEARCH_LDV,
        loadComponent: () =>
          import(
            './pages/utility/utility-search/utility-search.component'
          ).then((x) => x.UtilitySearchComponent),
      },
      {
        path: `${Path.SEARCH_LDV}/${Path.RISULTATO}/:searchTerm`,
        loadComponent: () =>
          import('./pages/utility/ldv/ldv.component').then(
            (x) => x.LdvComponent
          ),
      },
      {
        path: `${Path.SEARCH_FRAZIONARIO}`,
        loadComponent: () =>
          import(
            './pages/utility/utility-search/utility-search.component'
          ).then((x) => x.UtilitySearchComponent),
      },
      {
        path: `${Path.SEARCH_FRAZIONARIO}/${Path.FRAZIONARIO}/:searchTerm`,
        loadComponent: () =>
          import('./pages/utility/frazionario/frazionario.component').then(
            (x) => x.FrazionarioComponent
          ),
      },
      {
        path: `${Path.USER_MANAGEMENT}`,
        loadComponent: () =>
          import(
            './pages/utility/user-management/user-management.component'
          ).then((x) => x.UserManagementComponent),
      },
      {
        path: `${Path.USER_MANAGEMENT}/create`,
        loadComponent: () =>
          import(
            './pages/utility/user-management/pages/create-user/create-user.component'
          ).then((x) => x.CreateUserComponent),
      },
      {
        path: `${Path.MATERIAL_CATALOGUE}`,
        loadComponent: () =>
          import(
            './pages/utility/catalogo-materiale/catalogo-materiale.component'
          ).then((x) => x.CatalogoMaterialeComponent),
      },
      {
        path: `${Path.MATERIAL_CATALOGUE}/${Path.MASSIVE_UPLOAD}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.CLUSTER}`,
        loadComponent: () =>
          import('./pages/utility/cluster/cluster.component').then(
            (x) => x.ClusterComponent
          ),
      },
      {
        path: `${Path.CLUSTER}/${Path.MASSIVE_UPLOAD}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.CLUSTER}/${Path.MASSIVE_ASSOCIATION}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.ORDER_RULES}`,
        loadComponent: () =>
          import('./pages/utility/regole-ordine/regole-ordine.component').then(
            (x) => x.RegoleOrdineComponent
          ),
      },
      {
        path: `${Path.ORDER_RULES}/${Path.MASSIVE_UPLOAD}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.ORDER_CREATE}`,
        loadComponent: () =>
          import(
            './pages/utility/creazione-ordine/creazione-ordine.component'
          ).then((x) => x.CreazioneOrdineComponent),
      },
      {
        path: `${Path.ORDER_CREATE}/${Path.MASSIVE_UPLOAD}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.ORDER_CREATE}/${Path.RECOVERY}`,
        loadComponent: () =>
          import('./pages/massive-upload/massive-upload.component').then(
            (x) => x.MassiveUploadComponent
          ),
      },
      {
        path: `${Path.ORDERS_HISTORY}`,
        loadComponent: () =>
          import(
            './pages/utility/storico-ordini/storico-ordini.component'
          ).then((x) => x.StoricoOrdiniComponent),
      },
      {
        path: `${Path.SUPPLY_CONFIGURATION}`,
        loadComponent: () =>
          import(
            './pages/utility/configurazione-approvvigionamento/configurazione-approvvigionamento.component'
          ).then((x) => x.ConfigurazioneApprovvigionamentoComponent),
      },
      {
        path: `${Path.PIN_RECOVERY}`,
        canActivate: [refreshPasswordGuard],
        loadComponent: () =>
          import('./pages/utility/recupero-pin/recupero-pin.component').then(
            (x) => x.RecuperoPinComponent
          ),
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `${Path.USER_MANAGEMENT}`,
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    children: [
      {
        path: Path.HOME,
        loadComponent: () =>
          import('./pages/common/page-not-found/page-not-found.component').then(
            (x) => x.PageNotFoundComponent
          ),
      },
    ],
  },
];
